import { PaletteColor, Theme } from '@mui/material';

import { ColorOptions } from '../theme-next';

// Helper method to unclutter theme overrides
export const getStatePalette = (ownerState: { color?: ColorOptions }, theme: Theme): PaletteColor =>
    theme.palette[(ownerState.color !== 'inherit' && ownerState.color) || 'primary'];
